/* global process */
import axios from 'axios'

let orderAuditBase = window._env_.VUE_APP_ORDER_AUDIT_API_HOST

// exam_task 列表，用于审单系统配置中选择 exam_task_cfg_id
export function queryExamTaskTable (params, config) {
  // 兼容 remote-select 的输入：keyword 仅用于 id 精确匹配（数字时才下发）
  const keyword = params && (params.keyword || params.key || params.q)
  const id = keyword && String(keyword).match(/^\d+$/) ? Number(keyword) : undefined
  const body = Object.assign({}, params || {})
  body.id = id
  body.current_page = body.current_page || 1
  body.per_page = body.per_page || 50
  return axios.post(`${orderAuditBase}/admin/exam_task/query`, body, config)
}

export function queryAuditTaskSetting (params, config) {
  return axios.post(`${orderAuditBase}/admin/audit_task_setting/query`, params, config)
}

export function getExamTaskDetail (params, config) {
  return axios.get(`${orderAuditBase}/admin/exam_task/get_${params.id}`, config)
}

export function createAuditTaskSetting (params, config) {
  return axios.post(`${orderAuditBase}/admin/audit_task_setting/create`, params, config)
}

export function updateAuditTaskSetting (params, config) {
  const {id, ...body} = params || {}
  return axios.post(`${orderAuditBase}/admin/audit_task_setting/update_${id}`, body, config)
}

export function deleteAuditTaskSetting (params, config) {
  return axios.post(`${orderAuditBase}/admin/audit_task_setting/delete_${params.id}`, {}, config)
}

export function getAuditTaskSetting (params, config) {
  return axios.get(`${orderAuditBase}/admin/audit_task_setting/get_${params.id}`, config)
}

export function enableAuditTaskSetting (params, config) {
  return axios.post(`${orderAuditBase}/admin/audit_task_setting/enable_${params.id}`, {}, config)
}

export function disableAuditTaskSetting (params, config) {
  return axios.post(`${orderAuditBase}/admin/audit_task_setting/disable_${params.id}`, {}, config)
}




// WEBPACK FOOTER //
// ./src/views/audit-task-setting/audit-task-setting.api.js